import { CrateButton } from 'spa/components/track_buttons/crate_button'
import {
  DEFAULT_SHORT_DATE_OPTION,
  formatTrackLength,
} from '../../shared/utils'
import { DownloadTrackButton } from 'spa/components/track_buttons/download_track_button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { injectIntl } from 'react-intl'
import { SendToDownloaderButton } from 'spa/components/track_buttons/send_to_downloader_button'
import { TextStyle } from 'spa/components/typography'
import { trackSelector } from 'spa/selectors/songs'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

export const TrackListItem = injectIntl(
  ({
    bold,
    className,
    color,
    songId,
    trackId,
    fileDate,
    intl,
    showFileDate = true,
    showTrackLength = true,
    trackList,
  }) => {
    const track = useSelector(state =>
      trackSelector(state, { songId, trackId })
    )
    const { type, downloadCount } = track

    if (!color) {
      color = bold ? 'black' : 'grey'
    }
    return (
      <li className={classNames(styles.trackListItem, className)}>
        <div className={styles.checkContainer}>
          {downloadCount > 0 && (
            <FontAwesomeIcon className={styles.check} icon="check" />
          )}
        </div>
        <TextStyle
          className={styles.versionName}
          color={color}
          variant={bold ? 'extra-bold' : 'default'}
        >
          {type}
        </TextStyle>
        {showFileDate && fileDate && (
          <TextStyle className={styles.fileDate} color={color} variant="label">
            {intl.formatDate(fileDate, DEFAULT_SHORT_DATE_OPTION)}
          </TextStyle>
        )}
        {showTrackLength && track.trackLength && (
          <TextStyle className={styles.fileDate} color={color} variant="label">
            {formatTrackLength(track.trackLength)}
          </TextStyle>
        )}
        <DownloadTrackButton
          songId={songId}
          trackId={track.tid}
          trackList={trackList}
        />
        <CrateButton
          songId={songId}
          trackId={track.tid}
          trackList={trackList}
        />
        <SendToDownloaderButton
          songId={songId}
          trackId={track.tid}
          trackList={trackList}
        />
      </li>
    )
  }
)

TrackListItem.propTypes = {
  bold: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.oneOf(['black', 'white']),
  fileDate: PropTypes.any,
  intl: PropTypes.shape({
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  songId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  trackId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  trackList: PropTypes.string,
}
